










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NavBar extends Vue {
  
  @Prop({ default: [],  type: Array}) items!:string[];
  @Prop({ default: '',  type: String}) active!:string;

  clickHandler(menuItem:string) {
    this.$emit('navigate', menuItem);
  }
}
